import Axios from 'axios';

const customAxios = Axios.create({
  headers: {
    'Content-Type': 'text/plain'
  }
});

export function errorToTeams(reason: string, userAgent: IUAParser.IResult, username: string): Promise<any> {
  let teamsUrl = "https://zauzoocom.webhook.office.com/webhookb2/fa44a333-ddea-4c1b-acfd-693ac89da5a9@60b62049-2eac-4c01-acad-4e62d8ca8fef/IncomingWebhook/55b45351339f41fb975fccfa2f8d383b/f4ae6f61-d8b9-4d89-8b3d-99928cffc0fc";

  let title = "\u{1F4A3} " + reason.substring(0, 100);

  let message = {
    "@type":"MessageCard",
    "@context":"https://schema.org/extensions",
    "summary": title,
    "themeColor":"ff4444",
    "title": title,
    "sections":[
      {
        "facts":[
          {
            name: "browser",
            value: userAgent.browser.name + ' ' + userAgent.browser.version,
          },
          {
            name: "engine",
            value: userAgent.engine.name + ' ' + userAgent.engine.version,
          },
          {
            name: "os",
            value: userAgent.os.name + ' ' + userAgent.os.version,
          },
          {
            name: "device",
            value: userAgent.device.type + ' ' + userAgent.device.model + ' ' + userAgent.device.vendor,
          },
          {
            name: "user",
            value: username,
          }
        ]
      },
      {
        "text": "<pre>" + reason + "</pre>"
      }
    ]
  };


  return customAxios.post(teamsUrl, message).catch((error) => {
    console.log(error);
  });
}





// WEBPACK FOOTER //
// ./src/core/common/utils/logging.ts